<div
  class="logout-view"
  [style.background]="'url(/assets/images/' + background + ')'"
  [style.background-size]="'cover'"
>
  <div class="login-banner">
    <img src="/assets/images/apple-touch-icon-144x144-precomposed.png" height="64" style="display: inline-block; margin-top: -24px; margin-right: 24px; -webkit-filter: drop-shadow(1px 1px 0 grey) drop-shadow(-1px -1px 0 grey); filter: drop-shadow(1px 1px 0 grey) drop-shadow(-1px -1px 0 grey);"/>
    <h2 style="display: inline-block; margin-top: 12px;">Rail Viewer</h2>
  </div>
  <div
    class="logout-message"
  >

    <h2>Logging Out...</h2>

    <p>Clearing session, returning to Login page...</p>

  </div>

</div>
